import {Color} from '@/Types/Enums/Color'
import {type PeriodRequest} from '@/Types/Periods/PeriodRequest'

export const getPeriodRequestStatusColor = (rotation:PeriodRequest):Color => {
	if(rotation.is_pending){
		return Color.Yellow
	}
	if(rotation.needs_rescheduling){
		return Color.Purple
	}
	if(rotation.is_accepted){
		return Color.Green
	}
	if(rotation.is_rejected){
		return Color.Red
	}
	return Color.Neutral
}